import React from "react";
import useModalStore from "../../zustandStores/useModalStore";
import { premiumPopupsTypes } from "../../services/constants";
import UpgradeJob from "./UpgradeJob";
import PostPremiumJob from "./PostPremiumJob";
import PostPremiumJobV2 from "./PostPremiumJobV2";

const PremiumPopupRenderer = (): React.ReactNode => {
  const { modalData } = useModalStore(state => ({
    modalData: state.modalData
  }));

  const { upgradeJob, postPremiumJob, upgradeJobV2, postPremiumJobV2 } = premiumPopupsTypes;
  const { type } = modalData;

  switch (type) {
    case upgradeJob: {
      return <UpgradeJob />;
    }
    case postPremiumJob: {
      return <PostPremiumJob />;
    }
 
    case postPremiumJobV2: {
      return <PostPremiumJobV2 />;
    }
  }

  return null;
};

export default PremiumPopupRenderer;
